/*
 * Developed for G.J. Gardner Homes by Vicesoftware
 * http://www.softeq.com
 */

import { createRoute as createRouteBase, CreateRouteOptions } from '@gh/common-shared';
import { Route } from '@angular/router';
import { builderAuthGuard } from './builder-auth-guard.service';

export function createRoute(route: any, options?: CreateRouteOptions): Route {
  return createRouteBase(route, { ...options, authGuard: options?.authGuard ?? builderAuthGuard });
}

export type { CreateRouteOptions } from '@gh/common-shared';
